module.exports = "/d2d46eb3b5d2971804775096c0614c75.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/brands/diageo.png
 ** module id = 2205
 ** module chunks = 0
 **/